module.exports = __webpack_public_path__ + "img/fi-rr-ice-skate.72402675.svg";